import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93FQm56YYVyGMeta } from "/app/pages/[...all].vue?macro=true";
import { default as aboutu8Sb32ihwPMeta } from "/app/pages/about.vue?macro=true";
import { default as _91id_93PNbWpqMcNJMeta } from "/app/pages/account/[id].vue?macro=true";
import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as billing37vUkVEJP4Meta } from "/app/pages/billing.vue?macro=true";
import { default as _91id_93EYUsnZmxIRMeta } from "/app/pages/certificates/verify/[id].vue?macro=true";
import { default as changediNv4L5weDMeta } from "/app/pages/change.vue?macro=true";
import { default as codehEqPmROw1IMeta } from "/app/pages/code.vue?macro=true";
import { default as faqIMkmXQpKKaMeta } from "/app/pages/faq.vue?macro=true";
import { default as forgetDZfjyvZk2DMeta } from "/app/pages/forget.vue?macro=true";
import { default as helpgX3yoxbmc4Meta } from "/app/pages/help.vue?macro=true";
import { default as history2LdGTesqcBMeta } from "/app/pages/history.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as market2lqt9XD7gmMeta } from "/app/pages/market.vue?macro=true";
import { default as policyhDmBrXN4qOMeta } from "/app/pages/policy.vue?macro=true";
import { default as profileupBlgdy3vLMeta } from "/app/pages/profile.vue?macro=true";
import { default as refundcice5rlpWZMeta } from "/app/pages/refund.vue?macro=true";
import { default as registermu8R7rSP5uMeta } from "/app/pages/register.vue?macro=true";
import { default as termsy18ZESLqu6Meta } from "/app/pages/terms.vue?macro=true";
import { default as tradeaTbD2kYxp1Meta } from "/app/pages/trade.vue?macro=true";
import { default as withdrawI1z0D11N3gMeta } from "/app/pages/withdraw.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "all___en",
    path: "/en/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "all___fa",
    path: "/fa/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "all___zh",
    path: "/zh/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "all___es",
    path: "/es/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "all___hi",
    path: "/hi/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "all___ar",
    path: "/ar/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___fa",
    path: "/fa/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___zh",
    path: "/zh/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___hi",
    path: "/hi/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ar",
    path: "/ar/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "account-id___en",
    path: "/en/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account-id___fa",
    path: "/fa/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account-id___zh",
    path: "/zh/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account-id___es",
    path: "/es/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account-id___hi",
    path: "/hi/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account-id___ar",
    path: "/ar/account/:id()",
    component: () => import("/app/pages/account/[id].vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___fa",
    path: "/fa/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___zh",
    path: "/zh/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___es",
    path: "/es/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___hi",
    path: "/hi/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "billing___en",
    path: "/en/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "billing___fa",
    path: "/fa/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "billing___zh",
    path: "/zh/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "billing___es",
    path: "/es/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "billing___hi",
    path: "/hi/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "billing___ar",
    path: "/ar/billing",
    component: () => import("/app/pages/billing.vue")
  },
  {
    name: "certificates-verify-id___en",
    path: "/en/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "certificates-verify-id___fa",
    path: "/fa/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "certificates-verify-id___zh",
    path: "/zh/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "certificates-verify-id___es",
    path: "/es/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "certificates-verify-id___hi",
    path: "/hi/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "certificates-verify-id___ar",
    path: "/ar/certificates/verify/:id()",
    component: () => import("/app/pages/certificates/verify/[id].vue")
  },
  {
    name: "change___en",
    path: "/en/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "change___fa",
    path: "/fa/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "change___zh",
    path: "/zh/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "change___es",
    path: "/es/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "change___hi",
    path: "/hi/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "change___ar",
    path: "/ar/change",
    component: () => import("/app/pages/change.vue")
  },
  {
    name: "code___en",
    path: "/en/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "code___fa",
    path: "/fa/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "code___zh",
    path: "/zh/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "code___es",
    path: "/es/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "code___hi",
    path: "/hi/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "code___ar",
    path: "/ar/code",
    component: () => import("/app/pages/code.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___fa",
    path: "/fa/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___hi",
    path: "/hi/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ar",
    path: "/ar/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "forget___en",
    path: "/en/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "forget___fa",
    path: "/fa/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "forget___zh",
    path: "/zh/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "forget___es",
    path: "/es/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "forget___hi",
    path: "/hi/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "forget___ar",
    path: "/ar/forget",
    component: () => import("/app/pages/forget.vue")
  },
  {
    name: "help___en",
    path: "/en/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___fa",
    path: "/fa/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___zh",
    path: "/zh/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___es",
    path: "/es/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___hi",
    path: "/hi/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ar",
    path: "/ar/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "history___en",
    path: "/en/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "history___fa",
    path: "/fa/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "history___zh",
    path: "/zh/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "history___es",
    path: "/es/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "history___hi",
    path: "/hi/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "history___ar",
    path: "/ar/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fa",
    path: "/fa",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___fa",
    path: "/fa/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___zh",
    path: "/zh/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___hi",
    path: "/hi/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ar",
    path: "/ar/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "market___en",
    path: "/en/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "market___fa",
    path: "/fa/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "market___zh",
    path: "/zh/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "market___es",
    path: "/es/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "market___hi",
    path: "/hi/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "market___ar",
    path: "/ar/market",
    component: () => import("/app/pages/market.vue")
  },
  {
    name: "policy___en",
    path: "/en/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "policy___fa",
    path: "/fa/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "policy___zh",
    path: "/zh/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "policy___es",
    path: "/es/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "policy___hi",
    path: "/hi/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "policy___ar",
    path: "/ar/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___fa",
    path: "/fa/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___zh",
    path: "/zh/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___es",
    path: "/es/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___hi",
    path: "/hi/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___ar",
    path: "/ar/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "refund___en",
    path: "/en/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "refund___fa",
    path: "/fa/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "refund___zh",
    path: "/zh/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "refund___es",
    path: "/es/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "refund___hi",
    path: "/hi/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "refund___ar",
    path: "/ar/refund",
    component: () => import("/app/pages/refund.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___fa",
    path: "/fa/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___zh",
    path: "/zh/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___hi",
    path: "/hi/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ar",
    path: "/ar/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___fa",
    path: "/fa/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___zh",
    path: "/zh/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___es",
    path: "/es/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___hi",
    path: "/hi/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "trade___en",
    path: "/en/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "trade___fa",
    path: "/fa/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "trade___zh",
    path: "/zh/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "trade___es",
    path: "/es/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "trade___hi",
    path: "/hi/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "trade___ar",
    path: "/ar/trade",
    meta: tradeaTbD2kYxp1Meta || {},
    component: () => import("/app/pages/trade.vue")
  },
  {
    name: "withdraw___en",
    path: "/en/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: "withdraw___fa",
    path: "/fa/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: "withdraw___zh",
    path: "/zh/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: "withdraw___es",
    path: "/es/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: "withdraw___hi",
    path: "/hi/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: "withdraw___ar",
    path: "/ar/withdraw",
    component: () => import("/app/pages/withdraw.vue")
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/fa/sitemap.xml",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/hi/sitemap.xml",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubnO9MU04yTU
  }
]